import * as React from "react";
import { Link } from "react-router";

import { DefaultColumn, TableColumn, TableDtRefColumn } from "./DefaultColumn/DefaultColumn";
import { resolveFieldData } from "../../../helpers/utils/FieldDataResolver";


export const LinkColumn: React.FC<TableDtRefColumn> = (c) => {
  const bodyTemplate = (row: any, col: any) => {
    const content = c.body ? (c.body as Function)(row, col) : resolveFieldData(row, col.field);

    if (col["column"]?.["props"]?.url?.condition) {
      if (!col["column"]?.["props"]?.url.condition.show(resolveFieldData(row, col["column"]?.["props"]?.url.condition.field))) {
        return <span>{content}</span>;
      }
    }

    const urlProps = col["column"]?.["props"]?.url;
    const urlFieldValue = resolveFieldData(row, urlProps?.field);
    const url = urlProps?.getLinkURL?.(urlFieldValue);

    if (urlProps?.onClick) {
      return (
        <a
          className="pda-column-body-link"
          href="# "
          onClick={(e) => {
            e.preventDefault();
            urlProps.onClick?.(urlFieldValue);
          }}
        >
          {resolveFieldData(row, col.field)}
        </a>
      );
    }

    if (col.url?.href) {
      return (
        <a
          className="pda-column-body-link"
          href={url}
          {...(col["column"]?.["props"]?.url?.targetBlank ? { target: "_blank" } : {})}
        >
          {content}
        </a>
      );
    }

    return (
      <Link
        className="pda-column-body-link"
        to={url}
        {...(col["column"]?.["props"]?.url?.targetBlank ? { target: "_blank" } : {})}
      >
        {content}
      </Link>
    );
  }
  return DefaultColumn({
    ...c,
    bodyClassName: `pda-column-link ${c.bodyClassName ?? ``}`,
    headerClassName: `pda-column-link-header ${c.headerClassName ?? ``}`,
    body: bodyTemplate
  });
};
